import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

export default function useUserRole() {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const db = getFirestore();
    const personnelTypes = ["DentistOwner", "AssociateDentist", "ClinicStaff"];
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        for (const type of personnelTypes) {
          const userRef = doc(db, "users", user.uid);
          const snapshot = await getDoc(userRef);
          if (snapshot.exists()) {
            setUserRole(type);
            break;
          }
        }
      }
    });
    return () => unsubscribe();
  }, []);

  return userRole;
} 